import DraggableModal from 'components/DraggableModal';
import React from 'react';

import SearchSSHPublicKeysForm from './SearchSSHPublicKeysForm';
import {openDialogOutside} from 'common/openDialogOutside';
import {DialogTypes} from 'common/names';

type SearchSSHPublicKeysDialogProps = {
   // header: string;
   onClose: () => void;
};

const SearchSSHPublicKeysDialog = ({onClose}: SearchSSHPublicKeysDialogProps) => {
   const openOutside = React.useCallback(
      () => openDialogOutside(DialogTypes.SearchSSHPublicKeysDialog.id),
      []
   );

   return (
      <DraggableModal
         width={'md'}
         header={DialogTypes.SearchSSHPublicKeysDialog.dialogName}
         onClose={onClose}
         onLaunch={openOutside}
      >
         <SearchSSHPublicKeysForm onClose={onClose} />
      </DraggableModal>
   );
};

export default SearchSSHPublicKeysDialog;
